export const getCriteriosPrincipioSelecionado =
  (state) => state.criterios.listaCriteriosPrincipioSelecionado
export const getIsCarregandoCriteriosPrincipioSelecionado =
  (state) => state.criterios.isCarregandoListaCriteriosPrincipioSelecionado
